/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Backend_Session_Error_UnknownInputs */

const en_backend_session_error_unknown = /** @type {(inputs: Backend_Session_Error_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Backend error: ${i?.message}`)
};

const fr_backend_session_error_unknown = /** @type {(inputs: Backend_Session_Error_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur backend : ${i?.message}`)
};

const ms_sg2_backend_session_error_unknown = /** @type {(inputs: Backend_Session_Error_UnknownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ralat backend: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Backend error: {message}" |
*
* @param {Backend_Session_Error_UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_error_unknown = /** @type {((inputs: Backend_Session_Error_UnknownInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Error_UnknownInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_error_unknown(inputs)
	if (locale === "fr") return fr_backend_session_error_unknown(inputs)
	return ms_sg2_backend_session_error_unknown(inputs)
});